import { type CatalogItemSupplierWidget } from '../../../../components/CatalogItemDetails'
import {
  CatalogItemDetailsStatuses,
  type CatalogItemDetailsState,
} from '../../../../hooks/useCatalogItemDetails'
import {
  canHaveSupplierWidget,
  type ConversationCatalogItemComponent,
  findSupplierWidgetBlock,
} from '../../../../value-objects/ConversationTurnItem'

export const resolveSupplierWidget = (
  item: ConversationCatalogItemComponent,
  details: CatalogItemDetailsState
): Nullable<CatalogItemSupplierWidget> => {
  if (!canHaveSupplierWidget(item)) return null

  switch (details.status) {
    case CatalogItemDetailsStatuses.IDLE:
    case CatalogItemDetailsStatuses.LOADING:
      return { block: null }
    case CatalogItemDetailsStatuses.READY: {
      const block = findSupplierWidgetBlock(details.detailSections)
      return block ? { block } : null
    }
    default:
      return null
  }
}
